@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';
@import '../../global-styles/index.scss';

:host {
  margin-left: -16px;
  display: none;
  flex-direction: row;
  align-items: center;
  padding: 0;
  height: 100%;
  &:hover {
    .ciHeader {
      &-overlay {
        visibility: visible;
        opacity: 1;
      }
    }
  }
}

.active {
  display: block !important;
}
.ciHeader-subNav {
  &-item {
    display: flex;
    align-self: stretch;
    justify-content: stretch;
    text-decoration: none;
    color: $color-gray-slate-default;
    &:link, &:visited {
      color: $color-gray-slate-default;
    }
    &:hover {
      .ciHeader-subNav-text {
        background: $color-header-hover-blue;
        color: $color-blue-default;
      }
    }
    &:focus {
      outline: none;
      .ciHeader-subNav-text {
        border-radius: 4px;
        border: 1px solid $color-blue-default;
      }
    }
  }

  &-link {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    color: $color-gray-slate-default;
    &:link, &:visited {
      color: $color-gray-slate-default;
    }
  }

  &-text {
    display: inline-block;
    font-size: $typography-button-large-size;
    line-height: $typography-line-height;
    padding: 0.6rem;
    border-radius: 6px;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
    height: 100%;
    align-content: center;
    box-sizing: border-box;
  }

  .active {
    display: block;
  }
}

@include breakpoint('lg') {
  :host {
    display: flex;
  }
  .ciHeader-subNav {
    &-panel {
      display: none;
      position: absolute;
      background-color: $color-shade-white;
      z-index: 930;
      top: 49px;
      width: 976px;
      height: 374px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 0 0 1rem 1rem;
    }
    &-text {
      padding: 8px 12px;
    }
  }
  .ciHeader-navigation .ciHeader-subNav-panel {
    top: 49px;
    border-radius: 0 0 1rem 1rem;
  }
}

@include breakpoint('xl') {
  :host {
    display: flex;
  }
  .ciHeader-subNav {
    &-panel {
      display: none;
      position: absolute;
      background-color: $color-shade-white;
      z-index: 930;
       top: 49px;
      width: 1252px;
      height: 374px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 0 0 1rem 1rem;
    }
    &-text {
      padding: 8px 16px;
    }
  }
  .ciHeader-navigation .ciHeader-subNav-panel {
    top: 49px;
    border-radius: 0 0 1rem 1rem;
  }
}

#productOverlay, #apparelProductOverlay, #tShirtsProductOverlay {
  height: 470px;
}

#promoProductOverlay {
  height: 500px;
}

#designOverlay {
  height: 410px;
}

#solutionsOverlay {
  height: auto;
}

@media only screen and (min-width: 1300px) {
  #tShirtsProductOverlay {
    height: 460px;
  }
  #apparelProductOverlay {
    height: 530px;
  }
  #promoProductOverlay {
    height: 560px;
  }
}

#tShirtsProductOverlay-imageRemoved,
#promoProductOverlay-imageRemoved,
#apparelProductOverlay-imageRemoved {
  height: auto;
  padding: 1rem;
}
